import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { api, ApiError } from "@/lib/api";

/**
 * Layout `/_app/*`: todo lo que requiere sesión cuelga de aquí.
 * `beforeLoad` valida la cookie; si falla, redirect a /login.
 */
export const Route = createFileRoute("/_app")({
  component: AppShell,
  beforeLoad: async () => {
    try {
      await api.get("/auth/me");
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        throw redirect({ to: "/login" });
      }
      throw err;
    }
  },
});
